module.exports = __webpack_public_path__ + "static/media/bg-banners.f0660435.jpg";